import { render, staticRenderFns } from "./PageInstagramFeed.vue?vue&type=template&id=17353bae&scoped=true&"
import script from "./PageInstagramFeed.vue?vue&type=script&lang=js&"
export * from "./PageInstagramFeed.vue?vue&type=script&lang=js&"
import style0 from "./PageInstagramFeed.vue?vue&type=style&index=0&id=17353bae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17353bae",
  null
  
)

export default component.exports